import { useEffect, useState } from "react";
import {
  Button,
  Input,
  Textarea,
  Radio,
  Typography,
} from "@material-tailwind/react";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { httpPostProcessing } from "../../../services/http-common";

function EditWisdomMetaContent(props) {
  const { open, toogleOpenEditor, id } = props;
  const [scrapedContent, setScrapedContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [attemptLoading, setAttemptLoading] = useState(false);

  const errorFunc = (error) => {
    let message;
    message = error.response.data.message || error.message;
    toast.error(message);
  };

  const saveContent = useMutation(
    () => {
      return httpPostProcessing.put(
        `wisdom-docs/mine/update`,
        scrapedContent,
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data.message);
        toogleOpen();
      },
      onError: (error) => {
        errorFunc(error);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  const toogleOpen = () => {
    if (loading) return false;
    if (open) {
      setScrapedContent("");
    }
    toogleOpenEditor();
  };

  const onChangeContent = (e) => {
    if (loading) return false;
    setScrapedContent({ ...scrapedContent, [e.target.name]: e.target.value });
  };

  const toggleDisplay = (e) => {
    if (loading) return false;
    setScrapedContent({
      ...scrapedContent,
      [e.target.name]: !scrapedContent.private,
    });
  };

  const onSubmit = () => {
    saveContent.mutate(id);
  };

  const getDocDetails = useMutation(
    (docId) => {
      return httpPostProcessing.post(`wisdom-docs/find-by-id`, { id: docId });
    },
    {
      onSuccess: ({ data }) => {
        setScrapedContent(data.doc);
      },
      onError: (error) => {
        errorFunc(error);
      },
      onSettled: () => {
        setLoading(false);
      },
      onMutate: () => {
        setLoading(true);
      },
    }
  );

  const getDocDetailFunc = () => {
    if (id === null) return false;
    getDocDetails.mutate(id);
  };

  const reAttempt = useMutation(
    (docId) => {
      return httpPostProcessing.post(`wisdom-docs/re-attempt`, {
        ids: [docId],
      });
    },
    {
      onSuccess: ({ data }) => {
        toast.success(data?.message);
        setAttemptLoading(false);
        toogleOpenEditor();
      },
      onError: (error) => {
        errorFunc(error);
      },
      onSettled: () => {
        setAttemptLoading(false);
      },
      onMutate: () => {
        setAttemptLoading(true);
      },
    }
  );

  const reAttemptFunc = () => {
    if (id === null) return false;
    reAttempt.mutate(id);
  };

  useEffect(() => {
    getDocDetailFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      onClose={toogleOpen}
      scroll={"paper"}
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.9, y: -100 },
      }}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        className="flex justify-between items-center "
      >
        <div className="w-full  justify-start items-center">
          <span className="font-bold ">Edit MetaData: </span>{" "}
          {scrapedContent?.name}
        </div>
        <Button
          variant="gradient"
          size="sm"
          className="flex normal-case h-auto items-center !w-[110px] py-2 px-3"
          type="button"
          onClick={reAttemptFunc}
          disabled={attemptLoading}
        >
          <span>Reprocess</span>
        </Button>
      </DialogTitle>
      <DialogContent dividers={true}>
        {scrapedContent ? (
          <div className="p-4">
            {scrapedContent?.status === "rejected" && (
              <Alert severity="error">{scrapedContent?.rejectionReason}</Alert>
            )}
            <form className="mt-4 mb-2 space-y-4">
              <div>
                <Typography variant="small" className="mb-1">
                  Document title
                </Typography>
                <Input
                  type="text"
                  name="title"
                  value={scrapedContent?.title}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <Typography variant="small" className="mb-1">
                  Author(s)
                </Typography>
                <Input
                  type="text"
                  name="author"
                  value={scrapedContent?.author}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <Typography variant="small" className="mb-1">
                  Publication date
                </Typography>
                <Input
                  type="text"
                  name="publication_date"
                  value={scrapedContent?.publication_date}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <Typography variant="small" className="mb-1">
                  DOI (Digital Object Identifier)
                </Typography>
                <Input
                  type="text"
                  name="doi"
                  value={scrapedContent?.doi}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <Typography variant="small" className="mb-1">
                  Journal name
                </Typography>
                <Input
                  type="text"
                  name="journal_name"
                  value={scrapedContent?.journal_name}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <Typography variant="small" className="mb-1">
                  Abstract
                </Typography>
                <Textarea
                  name="abstract"
                  rows="3"
                  value={scrapedContent?.abstract}
                  onChange={onChangeContent}
                />
              </div>
              <div>
                <Typography variant="small" className="mb-1">
                  Notes
                </Typography>
                <Input
                  type="text"
                  name="notes"
                  value={scrapedContent?.notes}
                  onChange={onChangeContent}
                />
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center sm:gap-10">
                <Typography variant="small">
                  Can we display this publicly?
                </Typography>
                <div className="flex gap-3">
                  <Radio
                    id="private"
                    name="private"
                    label="Private"
                    onChange={toggleDisplay}
                    checked={scrapedContent?.private}
                  />
                  <Radio
                    id="public"
                    name="private"
                    label="Public"
                    onChange={toggleDisplay}
                    checked={!scrapedContent?.private}
                  />
                </div>
              </div>
            </form>
          </div>
        ) : (
          "Loading..."
        )}
      </DialogContent>
      <DialogActions className="space-x-2">
        <Button
          variant="text"
          size="sm"
          color="gray"
          className="mr-1 rounded-md waves-effect waves-light"
          onClick={toogleOpen}
          disabled={loading}
        >
          <span>Close</span>
        </Button>
        <Button
          size="sm"
          className="rounded-md waves-effect waves-light !bg-[#7a6fbe]"
          onClick={onSubmit}
          disabled={loading}
        >
          <span>Update</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditWisdomMetaContent;
